import React from "react";
import { Grid } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import TradingViewWidget from "react-tradingview-widget";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import { useSelector } from "react-redux";

const OIRightPanel = ({ styles }) => {
  const appReducer = useSelector((state) => state.appReducer);
  const { articles } = appReducer;
  const { quoteInfo } = appReducer;
  const { symbol } = quoteInfo;
  return (
    <Grid item md={3} style={{ height: "100%" }}>
      <div
        style={{
          height: "calc(100%)",
          paddingTop: "25px",
          paddingBottom: "30px",
          boxSizing: "border-box",
          background: "#D3D3D3",
        }}
      >
        <div style={styles.stockContainer}>
          {symbol && (
            <Paper elevation={5} style={styles.stockPaper} className="sticky">
              <TradingViewWidget
                symbol={symbol}
                referral_id="13279"
                width="100%"
                // width={100}
                height={250}
                hide_legend={true}
                hide_ideas={true}
                save_image={false}
                toolbar_bg="#f1f3f6"
                container_id="basic-area-chart"
              />
              <Typography
                variant="body1"
                component="p"
                style={styles.stockDelayText}
              >
                Stock prices in chart are delayed by 15 minutes.
              </Typography>
            </Paper>
          )}
        </div>
        <div style={styles.articlesTitleFixed}></div>
        <div style={styles.articlesFixed}>
          {articles.map((article, mKey) => {
            return (
              <div key={mKey} style={styles.newsContainer}>
                <div>
                  <img
                    style={styles.leftNewsPic}
                    src={article.image_url}
                    alt=""
                  />
                </div>
                <div style={styles.rightNews}>
                  <a href={article.news_url} target="_blank">
                    {article.title.length > 50
                      ? article.title.substring(0, 49) + "..."
                      : article.title}
                  </a>
                </div>
                <div style={{ fontSize: "0.8rem" }}>
                  {moment(article.date).format("MM/DD/YYYY")}
                  {" | By: " + article.source_name + " | "}
                  <span
                    style={
                      article.sentiment === "Neutral"
                        ? { color: "gray" }
                        : article.sentiment === "Negative"
                        ? { color: "red" }
                        : { color: "green" }
                    }
                  >
                    {article.sentiment}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Grid>
  );
};
export default OIRightPanel;



// WEBPACK FOOTER //
// ./src/Pages/OpenInterest/components/OIRightPanel.jsx